// WhatsApp utility functions
export const WHATSAPP_NUMBER = "5571981454372"; // Configure your number here

export const createWhatsAppLink = (message?: string): string => {
  const baseUrl = "https://wa.me/";
  const encodedMessage = message ? encodeURIComponent(message) : "";
  return `${baseUrl}${WHATSAPP_NUMBER}${encodedMessage ? `?text=${encodedMessage}` : ""}`;
};

export const createProductWhatsAppMessage = (
  productName: string,
  price: number,
  color?: string,
  size?: string,
  quantity: number = 1
): string => {
  let message = `Olá! Tenho interesse no produto:\n\n*${productName}*\nValor: R$ ${price.toFixed(2).replace(".", ",")}`;
  
  if (color) {
    message += `\nCor: ${color}`;
  }
  
  if (size) {
    message += `\nTamanho: ${size}`;
  }
  
  if (quantity > 1) {
    message += `\nQuantidade: ${quantity}`;
    message += `\nTotal: R$ ${(price * quantity).toFixed(2).replace(".", ",")}`;
  }
  
  message += `\n\nGostaria de mais informações!`;
  
  return message;
};

export const DEFAULT_WHATSAPP_MESSAGE = "Olá! Gostaria de saber mais sobre os produtos da Solar Crocheteria.";
